import { render, staticRenderFns } from "./SelectUserRoles.vue?vue&type=template&id=3e774230&scoped=true&"
import script from "./SelectUserRoles.vue?vue&type=script&lang=ts&"
export * from "./SelectUserRoles.vue?vue&type=script&lang=ts&"
import style0 from "./SelectUserRoles.vue?vue&type=style&index=0&id=3e774230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e774230",
  null
  
)

export default component.exports